import React, { useState, useCallback, useEffect } from 'react'
import { Header, Icon } from 'semantic-ui-react'
import { setZoom as setGlobalZoom, getZoom, subscribe } from './zoomStore'

const TableToolbar = React.memo(({
  title = '',
  onAdd = null,
  addText = 'Nuevo',
  onExportAll = null,
  exportFilename = 'export.csv',
  onRefresh = null,
  extraActions = [],
  children,
}) => {

  const [exporting, setExporting] = useState(false)
  const [localZoom, setLocalZoom] = useState(getZoom())

  useEffect(() => subscribe(setLocalZoom), [])

  const zoomOut = useCallback(() => {
    const z = Math.max(localZoom - 0.25, 0.5)
    setLocalZoom(z)
    setGlobalZoom(z)
  }, [localZoom])

  const zoomIn = useCallback(() => {
    const z = Math.min(localZoom + 0.25, 2)
    setLocalZoom(z)
    setGlobalZoom(z)
  }, [localZoom])

  const handleExport = useCallback(async () => {
    if (!onExportAll) return
    setExporting(true)
    try {
      const allData = await onExportAll()
      if (!allData || !allData.length) return

      const csv = allData.map(row =>
        row.map(cell => {
          const val = cell != null ? String(cell) : ''
          return val.includes(',') || val.includes('"') || val.includes('\n')
            ? `"${val.replace(/"/g, '""')}"`
            : val
        }).join(',')
      ).join('\n')
      const bom = '\uFEFF'
      const blob = new Blob([bom + csv], { type: 'text/csv;charset=utf-8;' })
      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = exportFilename
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      URL.revokeObjectURL(url)
    } finally {
      setExporting(false)
    }
  }, [onExportAll, exportFilename])

  return (
	<div className='SimpleTableToolbar' style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 10, flexWrap: 'wrap', position: 'relative', zIndex: 5 }}>
      {title && <Header as="h3" style={{ margin: 0, flexShrink: 0 }}>{title}</Header>}
      {onAdd && (
        <button
          type="button"
          onClick={onAdd}
          style={{
            background: '#4a6fa5', color: '#fff', border: 'none',
            borderRadius: 6, padding: '5px 14px', fontSize: 12,
            cursor: 'pointer', fontWeight: 600,
          }}
        >
          + {addText}
        </button>
      )}
      {onExportAll && (
        <button
          type="button"
          onClick={handleExport}
          disabled={exporting}
          style={{
            background: exporting ? '#9bc0a8' : '#388e3c', color: '#fff', border: 'none',
            borderRadius: 6, padding: '5px 14px', fontSize: 12,
            cursor: exporting ? 'default' : 'pointer', fontWeight: 600,
            display: 'inline-flex', alignItems: 'center', gap: 4,
          }}
        >
          {exporting ? 'Exportando...' : 'Exportar CSV'}
        </button>
      )}
      {onRefresh && (
        <button
          type="button"
          onClick={onRefresh}
          style={{
            background: '#4a6fa5', color: '#fff', border: 'none',
            borderRadius: 6, padding: '5px 14px', fontSize: 12,
            cursor: 'pointer', fontWeight: 600,
            display: 'inline-flex', alignItems: 'center', gap: 4,
          }}
        >
          <Icon name="refresh" />
          Actualizar
        </button>
      )}
      {extraActions.map((action, i) => (
        <button
          key={i}
          type="button"
          onClick={action.action}
          disabled={action.disabled}
          style={{
            background: action.disabled ? '#b0c4de' : '#5b7fa5', color: '#fff', border: 'none',
            borderRadius: 6, padding: '5px 14px', fontSize: 12,
            cursor: action.disabled ? 'default' : 'pointer', fontWeight: 600,
            display: 'inline-flex', alignItems: 'center', gap: 4,
          }}
        >
          {action.icon && <Icon name={action.icon} />}
          {action.label}
        </button>
      ))}
      <div className="SimpleTableToolbar" style={{ display: 'flex', alignItems: 'center', gap: 4, marginLeft: 'auto', fontSize: 11 }}>
        <button className="SimpleTableToolbar__zoomButton simple-table-zoom-button" type="button" onClick={zoomOut}
          style={{ width: 24, height: 24, borderRadius: 4, border: '1px solid #ddd', background: '#fff', cursor: 'pointer', fontSize: 14, lineHeight: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          −
        </button>
        <span className="simple-table-zoom-level" style={{ minWidth: 30, textAlign: 'center', fontWeight: 600, color: '#555' }}>{Math.round(localZoom * 100)}%</span>
        <button className="SimpleTableToolbar__zoomButton simple-table-zoom-button" type="button" onClick={zoomIn}
          style={{ width: 24, height: 24, borderRadius: 4, border: '1px solid #ddd', background: '#fff', cursor: 'pointer', fontSize: 14, lineHeight: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          +
        </button>
      </div>
      {children}
    </div>
  )
})

export default TableToolbar
